import { render, staticRenderFns } from "./LayoutApp.vue?vue&type=template&id=5323f4da&scoped=true&"
import script from "./LayoutApp.vue?vue&type=script&lang=js&"
export * from "./LayoutApp.vue?vue&type=script&lang=js&"
import style0 from "./LayoutApp.vue?vue&type=style&index=0&id=5323f4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323f4da",
  null
  
)

export default component.exports